export default () => ({
	setSorting: function(sortByVal = false) {
		var url = (new URL(document.location))
		var search_params = url.searchParams

		if (!sortByVal) {
			search_params.delete('sort')
		} else {
			search_params.set('sort', sortByVal)
		}

		// change the search property of the main url
		url.search = search_params.toString()
		// the new url string
		var new_url = url.toString()
		window.location.href = new_url
	}
})